const COLOURS = [
  '#A57BDB', // Purple
  '#33CCCC', // Cyan
  '#5FC8FF' // Blue
  //'#1576b6', // Blue
  //'#ff7e00', // Orange
  //'#24a122', // Green
  //'#d9241f', // Red
  //'#9464bf', // Purple ish
  //'#8d5549', // Red Dark
  //'#e574c4', // Pink
  //'#7e7e7e', // Grey
  //'#bcbe00', // Gold
  //'#00bed1' // Cyan
];

export const ColorScale = () => {
  let clone: any = [];
  const assigned: any = {};

  return (key: string) => {
    if (clone.length === 0) {
      clone = [...COLOURS];
    }

    if (assigned[key] === undefined) {
      assigned[key] = clone.shift();
    }
    return assigned[key];
  };
};
